import React, { useMemo } from "react";

import {
  BANK_DETAILS_CONTEXT,
  PAN_DETAIL_CONTEXT,
  KYC_DETAIL_CONTEXT,
  PAGE_SECTION,
  TODAY,
} from "../../constants";

const getBannerColors = (context, variant) => {
  if (variant === PAGE_SECTION.dashboard) {
    return {
      backgroundColor: context.dashboardBackgroundColor,
      textColor: context.dashboardTextColor,
    };
  }

  return {
    backgroundColor: context.backgroundColor,
    textColor: context.textColor,
  };
};

export const usePayoutBannerConfig = ({
  variant = PAGE_SECTION.details,
  sectionCompletion,
  processing,
  handleKYCVerification,
  onBankAction,
  onPanAction,
  kycVerificationClosingDate,
  isKYCExpired,
}) => {
  return useMemo(() => {
    const { bankDetails, panDetails, kycVerify } = sectionCompletion;

    const getKYCBannerText = (kycVerificationClosingDate, isKYCExpired) => {
      if (isKYCExpired) {
        return (
          <>
            <span className="tw-inline-block tw-mr-2 tw-rounded tw-px-2 tw-py-0.5 tw-bg-white tw-text-[#BF2600] tw-font-extrabold tw-uppercase tw-text-xs tw-tracking-wide">
              Payouts Paused
            </span>
            Complete your KYC verification to resume receiving payouts.
          </>
        );
      }

      return kycVerificationClosingDate === TODAY
        ? "Complete your KYC to continue receiving payouts"
        : `Complete your KYC within ${kycVerificationClosingDate} to continue receiving payouts`;
    };

    // CASE 1: Bank missing
    if (!bankDetails) {
      return {
        ...getBannerColors(BANK_DETAILS_CONTEXT, variant),
        text: BANK_DETAILS_CONTEXT.text,
        actionText: BANK_DETAILS_CONTEXT.actionText,
        onActionClick: onBankAction,
      };
    }

    // CASE 2: PAN missing
    if (bankDetails && !panDetails) {
      return {
        ...getBannerColors(PAN_DETAIL_CONTEXT, variant),
        text: PAN_DETAIL_CONTEXT.text,
        actionText: PAN_DETAIL_CONTEXT.actionText,
        onActionClick: onPanAction,
      };
    }

    // CASE 3: KYC pending
    if (bankDetails && panDetails && !kycVerify) {
      return {
        ...getBannerColors(KYC_DETAIL_CONTEXT, variant),
        text: getKYCBannerText(kycVerificationClosingDate, isKYCExpired),
        actionText: processing
          ? KYC_DETAIL_CONTEXT.actionLoading
          : KYC_DETAIL_CONTEXT.actionText,
        onActionClick: handleKYCVerification,
      };
    }

    return null;
  }, [
    variant,
    sectionCompletion,
    processing,
    handleKYCVerification,
    onBankAction,
    onPanAction,
  ]);
};
